import {useUnit} from 'effector-react';
import {useTranslation} from 'react-i18next';
import {
    $selectedUser,
    $usersList, $usersTable,
    getUsersListFx,
    selectUserEv, setUsersTableEv, UsersGate,
    $userGroupsMap
} from '../../models/adminModel/index.js';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import EditUserModal from './EditUserModal.jsx';

export default function AdminUsers() {
    const {t} = useTranslation()
    const {results, pagination} = useUnit($usersList)
    const loading = useUnit(getUsersListFx.pending)

    const selectUser = useUnit(selectUserEv)
    const selUser = useUnit($selectedUser)

    const grMap = useUnit($userGroupsMap)

    const setTable = useUnit(setUsersTableEv)
    const {limit, first} = useUnit($usersTable)

    const columns = [
        {field: 'username', header: t('Имя пользователя')},
        {field: 'firstName', header: t('Имя')},
        {field: 'lastName', header: t('Фамилия')},
        {field: 'groups', header: t('Группы'), body: (row) => row.groups?.map(g => grMap[g]).join(', ')},
        {field: 'isStaff', header: t('Админ'), align: 'center', body: (row) => row.isStaff ? <i className="pi pi-check" style={{color: '#28a745'}}/> : null},
        {field: 'isSuperuser', header: t('Супер'), align: 'center', body: (row) => row.isSuperuser ? <i className="pi pi-check" style={{color: '#28a745'}}/> : null},
        {field: 'email', header: t('Email')},
        {field: 'phone', header: t('Телефон')},
        {field: 'dateJoined', header: t('Дата регистрации'), body: (row) => row.dateJoined ? dayjs(row.dateJoined).format('YYYY-MM-DD HH:mm') : ''},
        {field: 'lastLogin', header: t('Последний вход'), body: (row) => row.lastLogin ? dayjs(row.lastLogin).format('YYYY-MM-DD HH:mm') : ''},
        {field: 'updatedAt', header: t('Обновлен'), body: (row) => row.updatedAt ? dayjs(row.updatedAt).format('YYYY-MM-DD HH:mm') : ''},
    ]

    return (
        <>
            <UsersGate/>
            {selUser ? <EditUserModal /> : null}
            <DataTable value={results}
                       stripedRows
                       showGridlines
                       lazy
                       first={first}
                       rows={limit}
                       loading={loading}
                       paginator
                       rowsPerPageOptions={[10, 20, 50]}
                       selectionMode={'single'}
                       totalRecords={pagination.totalRecords}
                       dataKey={'id'}
                       onSelectionChange={(e) => selectUser(e.value)}
                       onPage={e => {
                           setTable({
                               page: Math.ceil((e.first + e.rows) / e.rows),
                               offset: e.first,
                               totalPages: (pagination.totalPages),
                               limit: e.rows,
                               first: e.first
                           })
                       }}
            >
                {columns.map((col) =>
                    <Column
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        body={col.body ?? null}
                        align={col.align ?? 'left'}
                    />
                )}
            </DataTable>
        </>
    )
}